import { isValidEmail } from '@/micros/edit-project/grid-areas/main/audiences/utils';
import { GreenroomUserProfile } from '@/types/greenroom/profile.types';
import { CreateSpeaker, Speaker } from '@/types/speakers.types';
import { useMemo } from 'react';

const useValidateWorkingSpeaker = ({
  greenroomProfile,
  workingSpeaker,
}: {
  greenroomProfile: GreenroomUserProfile | null;
  workingSpeaker: Speaker | CreateSpeaker;
}) => {
  const validEmail = useMemo(() => {
    const isValid = isValidEmail(workingSpeaker.email || '');
    const hasGreenroomProfile = !!greenroomProfile;
    const hasContent = workingSpeaker.email?.length || 0 > 0;

    // valid entries for this field are
    // 1. the field has content and it is a valid email
    // 2. the field is empty and there is no greenroomProfile
    return isValid || (!hasGreenroomProfile && !hasContent);
  }, [greenroomProfile, workingSpeaker.email]);

  const validSpeaker = useMemo(() => {
    return (
      workingSpeaker.first_name.trim() &&
      workingSpeaker.last_name.trim() &&
      workingSpeaker.job_title?.base?.trim() &&
      workingSpeaker.company?.base?.trim() &&
      validEmail // if an invite has been sent, require an email for saving or require the email is valid if not sending greenroom invite
    );
  }, [
    validEmail,
    workingSpeaker.company?.base,
    workingSpeaker.first_name,
    workingSpeaker.job_title?.base,
    workingSpeaker.last_name,
  ]);

  const validImage = !!workingSpeaker?.image;

  return {
    validEmail,
    validSpeaker: validSpeaker && validImage,
    imageLikelyForgotten: validSpeaker && !validImage,
  };
};

export default useValidateWorkingSpeaker;
